import { gaWrapper } from 'helpers/analytics';

// eslint-disable-next-line import/prefer-default-export
export function sendGaThroughProps({ data }) {
  // const
  if (typeof data !== 'object') {
    return;
  }
  let { gaAction, gaLabel, gaCategory } = data;
  const { nonInteraction } = data;
  if (typeof gaAction === 'string' && typeof gaLabel === 'string') {
    if (!data.noSpaceReplace) {
      gaAction = gaAction.split(' ').join('');
    }
    gaAction = gaAction.split('&').join('');
    if (!data.noSpaceReplace) {
      gaLabel = gaLabel.split(' ').join('');
    }
    gaLabel = gaLabel.split('&').join('');
  }
  if (typeof gaCategory !== 'string') {
    gaCategory = window.categoryForGA;
  }
  let isGaInterActive =
    typeof window !== 'undefined' && window.isGaNonInteractive
      ? window.isGaNonInteractive
      : false;
  if (nonInteraction === true) {
    isGaInterActive = true;
  }
  if (
    typeof window !== 'undefined' &&
    window.categoryForGA &&
    data &&
    !isGaInterActive
  ) {
    gaWrapper('send', 'event', gaCategory, gaAction, gaLabel);
  }
  if (
    typeof window !== 'undefined' &&
    window.categoryForGA &&
    data &&
    isGaInterActive
  ) {
    gaWrapper('send', 'event', gaCategory, gaAction, gaLabel, {
      nonInteraction: 1,
    });
  }
}
